/**
 * Created by Omar Alejandro Leonor Avalos.
 * TODO: Implement isValid on form
 */
import React, { Component } from 'react';
import { SelectField, MenuItem, DatePicker, TextField, FlatButton, Card, CardHeader } from 'material-ui';
import AttachFile from 'material-ui/svg-icons/editor/attach-file';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import DropDownSearch from '../dropDownSearch';
import RemoteDropDownSearch from '../remotedropDownSearch';
import { findSelectedIndex, extractProperty, errorsEmpty } from '../../../common/helpers';
import { validateField, validateForm, buildErrorsState, fieldIsRequired } from '../../../validations';
import { AUTOCOMPLETE, DATE, SELECT, TEXT, FILE, REMOTE_AUTOCOMPLETE } from './types';

/**
 * Builds the state from keys, only one level, no nested fields
 * @param {array} fields
 */
const buildFormState = (fields) => {
    return Object.assign(...fields.map(({ key, value }) => ({ [key]: value || null })));
};

class FormBuilder extends Component {
    constructor() {
        super();
        this.state = {
            isValid: false,
            form: {},
            errors: {}
        };
    }

    componentWillMount() {
        const form = buildFormState(this.props.config.fields);
        const errors = buildErrorsState(this.props.config.fields);
        const isValid = errorsEmpty(errors);
        this.setState({ form, errors, isValid });
    }

    componentDidMount() {
        if (this.props.validateOnLoad) {
            const errors = validateForm(this.state.form, this.props.config.rules);
            const isValid = errorsEmpty(errors);
            this.props.onFormChange(isValid, this.state.form);
            this.setState({ errors, isValid });
        }
    }

    handleChange(event, key, value) {
        const form = { ...this.state.form, [key]: value };
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(this.props.config.rules, key, value)
        );
        const isValid =
            errorsEmpty({ ...errors, ...validateForm(form, this.props.config.rules) });
        this.props.onFormChange(isValid, form);
        this.setState({ form, errors, isValid });
    }

    functiontoAdd(form) {
        if (form.length === 1) {
            return '1 Archivo adjunto';
        }
        return `${form.length} Archivos adjuntos`;
    }

    buildForm(field) {
        const requiredMark = fieldIsRequired(field.key, this.props.config.rules) ? '(*)' : '';
        const floatingLabelText = `${field.floatingLabelText} ${requiredMark}`;
        const label = `${field.label} ${requiredMark}`;
        const props = { ...omit(field, 'fType', 'containerStyle', 'dropdownCustomId'), floatingLabelText, label };
        const dropdownCustomId = field.dropdownCustomId || 'id';

        switch (field.fType) {
            case REMOTE_AUTOCOMPLETE:
                return (
                    <RemoteDropDownSearch
                        {...props}
                        errorText={this.state.errors[field.key].join(' | ')}
                        value={this.state.form[field.key]}
                        onChange={(selectedItem) => {
                            this.handleChange(null, field.key, selectedItem.id);
                        }}
                    />
                );
            case AUTOCOMPLETE:
                return (
                    <DropDownSearch
                        {...props}
                        dataSource={extractProperty(field.data.items, 'name')}
                        errorText={this.state.errors[field.key].join(' | ')}
                        value={this.state.form[field.key]}
                        onUpdateInput={() => { this.handleChange(null, field.key, null); }}
                        onNewRequest={(request, index) => {
                            this.handleChange(null, field.key, field.data.items[index][dropdownCustomId]);
                        }}
                    />
                );
            case TEXT:
                return (
                    <TextField
                        {...props}
                        errorText={this.state.errors[field.key].join(' | ')}
                        onChange={(event, value) => this.handleChange(event, field.key, value)}
                        value={this.state.form[field.key] || ''}
                    />
                );
            case DATE:
                return (
                    <DatePicker
                        {...props}
                        errorText={this.state.errors[field.key].join(' | ')}
                        onChange={(event, value) => this.handleChange(event, field.key, value)}
                        value={this.state.form[field.key]}
                    />
                );
            case SELECT:
                return (
                    <SelectField
                        {...props}
                        errorText={this.state.errors[field.key].join(' | ')}
                        value={findSelectedIndex(field.data.items, this.state.form[field.key])}
                        onChange={(event, value) =>
                            this.handleChange(event, field.key, field.data.items[value].id)
                        }
                    >
                        {this.renderOptions(field.data)}
                    </SelectField>
                );
            case FILE:
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FlatButton
                            label={
                                this.state.form[field.key] ?
                                    this.functiontoAdd(this.state.form[field.key]) : 'Adjuntar'
                            }
                            containerElement="label"
                            icon={<AttachFile />}
                            labelPosition="before"
                        >
                            <input
                                type="file"
                                style={{ display: 'none' }}
                                multiple
                                onChange={
                                    (event) =>
                                        this.handleChange(event, field.key, event.target.files)
                                }
                            //value={this.state.form[field.key].name || ''}
                            />
                        </FlatButton>
                        <span style={{ color: 'red', marginLeft: '1rem' }}>
                            {this.state.errors[field.key].join(' | ')}
                        </span>
                    </div>
                );
            default:
                return null;
        }
    }

    commonRender(fields) {
        return fields.map((field, index) => {
            return (
                <div className="form-item" key={index} style={field.containerStyle}>
                    {this.buildForm(field)}
                </div>
            );
        });
    }

    sectionsRender(sections, fields) {
        return (
            <div style={{ marginTop: '2rem' }}>
                {sections.map((section, index) => {
                    return (
                        <Card key={index} style={{ width: '100%', marginBottom: '1rem' }}>
                            <CardHeader title={section.title} />
                            <div style={{ display: 'flex', alignItems: 'flex-end', padding: '2rem' }}>
                                {
                                    section.keys.map((key, idx) =>
                                        <div style={{ paddingLeft: '1rem' }} key={idx}>
                                            {this.buildForm(fields.find(field => field.key === key))}
                                        </div>
                                    )
                                }
                            </div>
                        </Card>
                    );
                })}
            </div>
        );
    }

    renderOptions(data) {
        const { displayProp, items } = data;
        return items.map((item, index) =>
            <MenuItem primaryText={displayProp(item)} key={index} value={index} />
        );
    }

    renderForm(config) {
        const { fields, sections } = config;
        return (
            sections ? this.sectionsRender(sections, fields) :
                <div className="form-container">{this.commonRender(fields)}</div>
        );
    }

    render() {
        return this.renderForm(this.props.config);
    }
}

FormBuilder.propTypes = {
    config: PropTypes.shape({
        fields: PropTypes.arrayOf(PropTypes.object).isRequired
    }).isRequired
};

export default FormBuilder;



// WEBPACK FOOTER //
// ./components/data-containers/formBuilder/index.js